import React, {useState, useEffect} from 'react';
import {useDialogueGuideSettings} from "../hooks/useDialogueGuideSettings.mjs";
import {isSurveyPage, notifyInfo, sendResultsViaEmail, useDispatch, useGuideConfig, useNeuroMessages} from "@ignitesales/neuro-application";
import {confirmAlert} from "react-confirm-alert";
import {useDialogueContext} from "../hooks/useDialogueContext.mjs";

const ContactOnExit = ({ onComplete }) => {
    const appDispatch = useDispatch();
    const {getMessage} = useNeuroMessages();
    const {isBranchGuide} = useGuideConfig();
    const {shouldWarnOnClose} = useDialogueGuideSettings();
    const {contactPageCompleted} = useDialogueContext();
    const inputFieldId = 'contactOnExitEmail';
    const title = getMessage('contactOnExit.title');
    const text = getMessage('contactOnExit.text');
    const [hasBeenOpened, setHasBeenOpened] = useState(false); //TODO: consider using local storage to init this value - JJ

    const onSubmit = (onClose) => {
        const email = document.getElementById(inputFieldId).value;
        //TODO: need to save answer value that let's us know this process was completed - JJ
        appDispatch( sendResultsViaEmail({ email }));
        onComplete && onComplete(email);
        notifyInfo('contactOnExitToast');
        onClose();
    };

    const onAlert = () => confirmAlert({
        customUI: ({onClose}) => <div className='contactOnExit'>
            <i className="ion-md-close-circle-outline contactOnExit__icon" onClick={onClose} />
            <h1>{ title }</h1>
            <p>{ text }</p>
            <div className="contactOnExit__form">
                <input type="text" name='email' id={inputFieldId} />
                <button type="submit" onClick={() => onSubmit(onClose)}>Submit</button>
            </div>
        </div>
    });

    const warnBeforeUnloading = (event) => {
        if (shouldWarnOnClose && !isBranchGuide && !contactPageCompleted && isSurveyPage()) {
            event.preventDefault();
            setTimeout(() => {
                setHasBeenOpened(true);
                onAlert();
            }, 5000);
            event.returnValue = true;
        }
    };

    useEffect(() => {
        if(!hasBeenOpened) {
            window.addEventListener('beforeunload', warnBeforeUnloading);
        } else {
            window.removeEventListener('beforeunload', warnBeforeUnloading);
        }
        return () => {
            window.removeEventListener('beforeunload', warnBeforeUnloading);
        };
    }, [hasBeenOpened]);

    return null;
}

export default ContactOnExit;
